// @flow
import React from 'react';
import classNames from 'classnames';
import Box from 'sail/Box';
import {CopyTextButton} from '../CopyTextButton';

export function CreateShellCommand(command: string) {
  return () => <Shell command={command} />;
}

export default function Shell({
  command,
  shell,
  large,
}: {|
  command: string,
  shell?: boolean,
  large?: boolean,
|}) {
  const classes = classNames(
    'Terminal-code',
    shell && 'shell',
    large && 'large',
  );

  return (
    <Box
      style={{
        height: 'auto',
        borderRadius: '4px',
        margin: '4px 0',
        padding: '8px 12px',
        overflow: 'auto',
      }}
      margin={{vertical: 4}}
      padding={{horizontal: 12, vertical: 8}}
      divider={{color: 'light', width: 1, side: 'all'}}
      flex={{justifyContent: 'space-between', alignItems: 'center'}}
    >
      <div style={{overflow: 'auto', marginRight: '15px'}}>
        <code
          style={{
            whiteSpace: large ? 'break-spaces' : 'nowrap',
            fontSize: large ? '11px' : '14px',
            lineHeight: '20px',
          }}
          className={classes}
        >
          {command}
        </code>
      </div>
      <CopyTextButton
        style={{cursor: 'pointer', margin: 0, alignSelf: 'flex-start'}}
        color="blue"
        size={12}
        iconPosition="right"
        text={command}
      />
    </Box>
  );
}
